import { Pipe, PipeTransform } from '@angular/core';
import { formatAuditTimestamp } from '../utils';

/**
 * Formats an ISO timestamp to "MM/DD/YYYY H:MMam/pm", optionally suffixed with " by {userId}".
 * Pure pipe — memoized by input, so it only recomputes when the value or userId changes.
 *
 * Usage: {{ tmstmpValue | timestampFormat }} or {{ tmstmpValue | timestampFormat: userId }}
 */
@Pipe({ name: 'timestampFormat' })
export class TimestampFormatPipe implements PipeTransform {
  transform(value: string | null | undefined, userId?: string | null): string {
    return formatAuditTimestamp(value, userId);
  }
}
